module.exports = __webpack_public_path__ + "static/media/Logo-Arlet-White.84b69ca2.png";